<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="studentDiligences"
      item-key="id"
      :server-items-length="studentCount"
      :options.sync="tableOptions"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
      disable-sort
    >
      <!-- Học sinh -->
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Ngày sinh -->
      <template v-slot:[`item.dob`]="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <!-- Lớp -->
      <template v-slot:[`item.class`]="{ item }">
        {{ item.student | _get('currentClass.title') }}
      </template>
      <!-- Số ngày nghỉ -->
      <template v-slot:[`item.absentNo`]="{ item }">
        {{ item.diligences.length }}
      </template>
      <!-- Có phép -->
      <template v-slot:[`item.valid`]="{ item }">
        {{ item.diligences.filter(d => d.type === 'valid').length }}
      </template>
      <!-- Không phép -->
      <template v-slot:[`item.invalid`]="{ item }">
        {{ item.diligences.filter(d => d.type === 'invalid').length }}
      </template>
      <!-- Thao tác -->
      <template v-slot:[`item.action`]="{ item }">
        <v-btn class="elevation-0" icon @click="openDiligenceDetailDialog(item.student, item.diligences)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DiligenceDetailDialog
      :state="addDiligence"
      :student="selectedStudent"
      :diligences="selectedDiligences"
      @createdDiligence="searchStudentDiligences(studentSearchParams)"
      @updateDiligence="searchStudentDiligences(studentSearchParams)"
      @deletedDiligence="searchStudentDiligences(studentSearchParams)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import utils from '@/plugins/utils'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DiligenceDetailDialog from './DiligenceDetailDialog.vue'

const defaultHeaders = [
  { text: 'Học sinh', value: 'student' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Lớp', value: 'class', align: 'center' },
  { text: 'Số ngày nghỉ', value: 'absentNo', align: 'center' },
  { text: 'Có phép', value: 'valid', align: 'center' },
  { text: 'Không phép', value: 'invalid', align: 'center' },
  { text: 'Thao tác', value: 'action', align: 'center' }
]
export default {
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5
      },
      selectedStudent: {},
      selectedDiligences: [],
      addDiligence: false,
      studentSearchParams: {},
      studentCount: 0,
      loading: false
    }
  },
  components: {
    CardStudentName,
    DiligenceDetailDialog
  },
  computed: {
    ...mapState('Diligence', ['studentDiligences']),
    ...mapGetters('auth', ['ownClassIds']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.studentCount)
      }
      if (this.studentCount > 100) {
        footerOptions['items-per-page-options'] = [5, 10, 15]
      }
      return footerOptions
    }
  },
  methods: {
    ...mapActions('students', ['getStudentCount']),
    ...mapActions('Diligence', ['getStudentDiligences']),
    openDiligenceDetailDialog(student, diligences) {
      this.addDiligence = !this.addDiligence
      this.selectedStudent = student
      this.selectedDiligences = diligences
    },
    async searchStudentDiligences(filters) {
      this.loading = true
      // New filter
      if (filters) {
        this.tableOptions.page = 1
        const studentFilters = {}
        if (filters.student) {
          studentFilters.id = filters.student
        } else {
          if (filters.class) {
            studentFilters.currentClass = filters.class
          } else {
            if (filters.grade) {
              studentFilters.grade = filters.grade
            }
            if (this.ownClassIds) {
              studentFilters['currentClass_in'] = this.ownClassIds
            }
          }
        }
        this.getStudentCount(studentFilters)
          .then(response => {
            this.studentCount = response
          })
          .catch(error => {
            console.error(error)
            this.$alert.error('Không lấy được số lượng học sinh')
          })
        this.studentSearchParams = { ...studentFilters, ...this.pageSetting() }
      } else {
        this.studentSearchParams = { ...this.studentSearchParams, ...this.pageSetting() }
      }
      try {
        await this.getStudentDiligences(this.studentSearchParams)
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần')
        console.error(error)
      }
      this.loading = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: 'nameToNumber:ASC'
      }
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.searchStudentDiligences()
        }
      },
      deep: true
    }
  }
}
</script>
